var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "light-blue-board mix-board mt_10" },
    [
      _c("div", [
        _c("div", { staticClass: "mix-title" }, [
          _c("div", { staticClass: "title-name" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.itemData.title || _vm.title) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title-value" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.itemData.finishRate
                    ? _vm.paddingNum(_vm.itemData.finishRate)
                    : 0
                ) +
                "%\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "values" }, [
        _c("div", { staticClass: "nums" }, [
          _c("span", { staticClass: "num1" }, [
            _vm._v(
              _vm._s(
                _vm.paddingNum(_vm.itemData.actualCount) == 0
                  ? "-"
                  : _vm.paddingNum(_vm.itemData.actualCount)
              )
            ),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "space" }, [_vm._v("/")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.paddingNum(_vm.itemData.sopCount) == 0
                  ? "-"
                  : _vm.paddingNum(_vm.itemData.sopCount)
              )
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("el-progress", {
        attrs: {
          percentage:
            _vm.itemData.finishRate > 100 ? 100 : _vm.itemData.finishRate,
          color: _vm.color,
          "show-text": false,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }